var map = {
	"./pdf/brochures/Niva-Bupa-ReAssure-2-bronze.pdf": 24397,
	"./pdf/brochures/bajaj-allianz-life.pdf": 5328,
	"./pdf/brochures/care-advantage.pdf": 25838,
	"./pdf/brochures/care-arogya-sanjeevani.pdf": 67737,
	"./pdf/brochures/care-freedom-diabetes.pdf": 68535,
	"./pdf/brochures/care-freedom.pdf": 90095,
	"./pdf/brochures/care-heart.pdf": 49541,
	"./pdf/brochures/care-joy.pdf": 76779,
	"./pdf/brochures/care-plus.pdf": 37907,
	"./pdf/brochures/care-supreme-direct.pdf": 49110,
	"./pdf/brochures/care-supreme.pdf": 28444,
	"./pdf/brochures/diabetes-safe-plan-B.pdf": 43869,
	"./pdf/brochures/hdfc-click-2-protect-super.pdf": 91234,
	"./pdf/brochures/hdfc-ultimate.pdf": 27144,
	"./pdf/brochures/indiafirst-life-guaranteed-protection-plus-plan.pdf": 11933,
	"./pdf/brochures/isecure-insurance-plan.pdf": 5602,
	"./pdf/brochures/niva-arogya-sanjeevani.pdf": 88990,
	"./pdf/brochures/niva-aspire-gold+.pdf": 32046,
	"./pdf/brochures/niva-companian.pdf": 40666,
	"./pdf/brochures/niva-go-active.pdf": 96411,
	"./pdf/brochures/niva-premia.pdf": 57756,
	"./pdf/brochures/niva-pulse-enhanced.pdf": 69004,
	"./pdf/brochures/niva-reAssure-bronze.pdf": 50567,
	"./pdf/brochures/niva-reAssure.pdf": 41462,
	"./pdf/brochures/niva-rise.pdf": 12925,
	"./pdf/brochures/niva-super-saver.pdf": 73027,
	"./pdf/brochures/smart-health-pro.pdf": 51581,
	"./pdf/brochures/star-comprehensive-with-PED-Buyback-Rider.pdf": 31910,
	"./pdf/brochures/star-comprehensive.pdf": 85706,
	"./pdf/brochures/star-health-assure.pdf": 80214,
	"./pdf/brochures/super-star.pdf": 28611,
	"./pdf/brochures/tata-medicare-lite.pdf": 57819,
	"./pdf/brochures/tata-medicare-plus.pdf": 6783,
	"./pdf/brochures/tata-medicare-premier.pdf": 1757,
	"./pdf/brochures/tata-medicare.pdf": 76701,
	"./pdf/brochures/tata-sampoorna-raksha-promise.pdf": 41785,
	"./pdf/brochures/young-star.pdf": 81580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65722;